export const BASE_URL = process.env.REACT_APP_BASE_URL || "https://rythm-backend.onrender.com/api/v1";

